<template>
    <div class="pt-8">
        <FilterForm
            :filter="filter" 
            :categoriesList="categoriesList" 
            @get-items-list-empresa="getInventoryListEmpresa()" 
            @clear-filter-form="clearFilterForm()"  
        />

        <MassiveImport @close-modal="closeMassiveImportModal" @massive-import-send="massiveImportSend = true" :openModal="massiveImportModal"/>

        <ItemsTable 
            :items="items" 
            :paginator="paginator" 
            :pageSize="pageSize"  
            :urlWebBackend="urlWebBackend"
            :user="user"
            :opcionExistencia="opcionExistencia"
            @get-items-list-empresa="getInventoryListEmpresa()" 
            @change-page="changePage($event)" 
            @update-status-item="updateStatusItem($event)"
            @update-archived-item="updateArchivedItem($event)"
            @open-massive-import-modal="massiveImportModal = true"
        />
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import FilterForm from '../components/FilterForm.vue'
import ItemsTable from '../components/ItemsArchivedTable.vue'
import MassiveImport from '../components/MassiveImportItemEmpresa.vue'
export default {
    computed: {
        ...mapState('configuration', ['urlWebBackend']),
        ...mapState('auth', ['user']),
    },
    data(){
        return{
            items: [],
            filter: {
                nombre: '',
                codigoItem: '',
                categoryId: '',
            },
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 10,
            },
            pageSize: [10, 25, 50, 100],
            pageOptions: "",
            opcionExistencia: 0,
            categoriesList: [],
            massiveImportModal: false,
            massiveImportSend: false,
        }
    },
    components: {
        FilterForm,
        ItemsTable,
        MassiveImport
    },
    created(){
        this.getInventoryListEmpresa();
        this.getCategoriesList();
    },
    methods:{
        ...mapMutations(['setLoading']),    
        async getInventoryListEmpresa(){

            // if(typeof this.categoryId === "undefined"){
            //     this.categoryId = "";
            // }
            this.pageOptions = {
                pageNumber: this.paginator.page, 
                pageSize:   this.paginator.pageSize,
                nombre:     this.filter.nombre,
                //reemplazar item por codigoItem en el backend y actualizar esta linea
                item:       this.filter.codigoItem,
                categoryId: this.filter.categoryId,
            }
            this.setLoading(true)
            await this.$conectar.post('/empresa/items/get-inventory-archived-list', this.pageOptions)
            .then(response =>{
                this.items = response.data.itemsEmpresaLists;
                this.paginator.totalPage = response.data.totalPages;
                this.opcionExistencia = response.data.opcionExistencia;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        changePage(page){
            this.paginator.page = page;
            this.getInventoryListEmpresa();
        },
        async getCategoriesList(){
            this.setLoading(true)
            await this.$conectar.post('/empresa/categories/get-categories-list', {category_id: this.$route.params.id})
            .then(response =>{
                this.categoriesList = response.data.categoriesList;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async updateArchivedItem(item){
            item.is_archived = !item.is_archived
            this.pageOptions = {item_id: item.id, is_archived: item.is_archived}
            this.setLoading(true)
            await this.$conectar.post('/empresa/items/update-archived-item', this.pageOptions)
            .then(response =>{
                if(response.data.error == true){
                    item.is_archived = !item.is_archived;
                    this.$bvToast.toast(response.data.errorMessage, {
                        title: "Respuesta del servidor",
                        variant: "danger",
                        solid: true
                    })
                }else{
                    this.$bvToast.toast('Item actualizado correctamente', {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                    this.getInventoryListEmpresa();
                }

            })
            .catch(e => {
                console.log(e.response);
                item.is_archived = !item.is_archived;
                this.$bvToast.toast("Parece que hubo un error en el servidor, por favor intente mas tarde, si el problema persiste, contacte al administrador.", {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
                
            })
            this.setLoading(false)
        },
        clearFilterForm(){
            this.filter.nombre = "";
            this.filter.codigoItem = "";
            this.filter.categoryId = "";
            this.paginator.pageSize = 10;
        },
        closeMassiveImportModal(){
            this.massiveImportModal = false;
            if(this.massiveImportSend == true){
                this.getInventoryListEmpresa();
                this.massiveImportSend = false;
            }
        },
    }
}
</script>